import React, { Component } from 'react';
import { Pagination, Panel, Form, FormField, Dialog, NumberBox, Label, ButtonGroup, Messager, DataGrid, DateBox, GridColumn, LinkButton, ComboBox, TextBox, MaskedBox, Button } from 'rc-easyui';
import { API_URL } from '../../../../constants';
import { getAccessToken, getCookie } from '../../../../helpers/cookieHelper';
import axios from 'axios';
import { getUserId } from '../../../../helpers/AuthHelper';
import { isEmpty } from '../../../../helpers/Common';
import { exportToCSV, getFormattedDate } from '../../../../helpers';
import "../../../reports/Report.css"
export class TimesheetSystemReport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            statusData: [{ value: "Draft", text: "Draft" }, { value: "Submitted", text: "Submitted" }, { value: "Approved", text: "Approved" }, { value: "Rejected", text: "Rejected" }],
            pageArray: [],
            currentDateTime: null,
            StatusList: [],
            pageOptions: {},
            searchparam: {
                fromdate: '',
                todate: '',
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                userId: "",
                enabled: true,
            },
            isLoading: false,
            pageOptions: {
                pageOptions: {
                    layout: [
                        "list",
                        "sep",
                        "first",
                        "prev",
                        "next",
                        "last",
                        "sep",
                        "refresh",
                        "sep",
                        "manual",
                        "info",
                    ],
                },
            },

            subprojectList: [],
            projectList: [],
            user: [],
            permissions: {},
            viewPermission: false,
            data: [],
            showReport: false,
            totalTimeSpent: ""
        }
    }

    componentDidMount = async () => {
        var data = getCookie('permission');

        const date = new Date();
        let fullYear = date.getFullYear();
        let fullMonth = date.getMonth()
        let fullDay = date.getDate()
        let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
        const today = formattedDate;

        const timestamp = date.getTime();
        const sevenDaysTimeStamp = timestamp - 7 * 24 * 60 * 60 * 1000;
        const sevenDaysDate = new Date(sevenDaysTimeStamp);
        let sfullYear = sevenDaysDate.getFullYear();
        let sfullMonth = sevenDaysDate.getMonth()
        let sfullDay = sevenDaysDate.getDate()
        let formattedFromDate = sfullYear + '-' + (sfullMonth + 1) + '-' + sfullDay

        if (JSON.parse(data).includes("hrm-view") && JSON.parse(data).includes("project-view")) {
            this.setState({ viewPermission: true })
        }


        this.setState({
            isNull: false,
            permissions: JSON.parse(data),
            pageOptions: {
                loading: true,
                pageOptions: {
                    pageNumber: 1,
                    pageSize: 100,
                    pagePosition: 'bottom',
                    pageList: [10, 20, 30, 40, 50, 60, 70, 80],
                    layout: [
                        'list',
                        'sep',
                        'first',
                        'prev',
                        'next',
                        'last',
                        'sep',
                        'refresh',
                        'sep',
                        'manual',
                        'info',
                    ],
                },
            },
            searchparam: {
                fromdate: new Date(formattedFromDate),
                todate: new Date(today),
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                userId: "",
                enabled: true,
            },


        },
            async () => {
                await this.getProjectId()
                await this.getSubProjectId()
                await this.getUsers()
            })
    }


    getProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforprojectinfo?enabled=1`
            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            projectList: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            projectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        projectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getProjectId()
            }
        }

    }

    getSubProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforsubprojectinfo?enabled=1`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            subprojectList: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            subprojectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        subprojectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getSubProjectId()
            }
        }

    }

    getUsers = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })

            let url = `${API_URL}api/users`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data
                        // console.log(dataObject);
                        this.setState({
                            user: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            user: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        user: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getUsers()
            }
        }
    }

    getData = async () => {
        const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
        const { fromdate, todate, projectId, subprojectId, status, enabled, comments, userId } = this.state.searchparam;
        if (fromdate == null || todate == null || userId == "") {
            alert("Please fill all the required field")
            return
        }
        var access_token = getCookie("access_token");
        var token_type = getCookie("token_type");
        let headerConfig = {
            headers: {
                authorization: token_type + " " + access_token,
                "Content-Type": "application/json",
            }
        }
        let enable = true;
        if (enabled) {
            enable = 1
        } else {
            enable = 0
        }
        var url = `${API_URL}api/gettimesheetsystemwithpagination?fromdate=${getFormattedDate(fromdate)}&todate=${getFormattedDate(todate)}&projectid=${projectId}&subprojectid=${subprojectId}&userid=${userId}&status=${status}&enabled=${enable}&page=${pageNumber}&rows=${pageSize}&loginid=`;
        this.setState({
            pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: true,
            },
            isLoading: true
        });
        if (access_token != null) {
            await axios.get(url, headerConfig)
                .then((response) => {
                    if (response.status === 200) {

                        if (response.data.rows.timesheetSystemlist.length === 0) {
                            this.setState({
                                showReport: false,
                                isLoading: false
                            })
                            this.messager.alert({
                                title: 'Info',
                                icon: 'info',
                                msg: "No data found!",
                                reload: false
                            })
                        } else {
                            this.getCurrentDateTime()
                            let pageArr = response.data.rows.timesheetSystemlist;
                            let totalTimeSpent = response.data.rows.totalTimeSpent
                            pageArr.map(data => {
                                this.state.projectList.map(projectlist => {
                                    if (data.projectId === projectlist.id) {
                                        data.projectId = projectlist.name
                                    }
                                })
                                this.state.subprojectList.map(subprojectlist => {
                                    if (data.subprojectId === subprojectlist.id) {
                                        data.subprojectId = subprojectlist.name
                                    }
                                })
                                let newdate = new Date(data.dateAd)
                                let fullYear = newdate.getFullYear()
                                let fullMonth = newdate.getMonth()
                                let fullDay = newdate.getDate()
                                newdate = fullYear + '-' + fullMonth + '-' + fullDay
                                data.dateAd = newdate
                                this.state.user.map(u => {
                                    if (data.userId == u.id) {
                                        data['timesheetOf'] = u.fullname
                                    }
                                })
                                delete data['timeSpentInMinutes']
                                delete data['enabled']
                                delete data['userId']
                                delete data['lastModifiedIn']
                                delete data['createdIn']
                                delete data['id']
                            })

                            let total = response.data.total;
                            console.log(pageArr);
                            this.setState({
                                pageArray: pageArr,
                                pageOptions: {
                                    pageOptions: {
                                        pageSize: 100,
                                        pageList: [20, 50, 30, 100, total].sort(
                                            function (a, b) {
                                                return a - b;
                                            }),
                                        total: total,
                                        ...this.state.pageOptions.pageOptions,
                                    },
                                    loading: false,
                                },
                                data: pageArr,
                                isLoading: false,
                                showReport: true,
                                totalTimeSpent: totalTimeSpent
                            });
                        }


                    } else {
                        this.setState({
                            pageOptions: {
                                pageOptions: { ...this.state.pageOptions.pageOptions },
                                loading: false,
                            },
                            isLoading: false
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        pageOptions: {
                            pageOptions: { ...this.state.pageOptions.pageOptions },
                            loading: false,
                        },
                    });
                });
        } else {
            const resp = await getAccessToken();
            if (resp) {
                this.getData();
            }
        }
    }

    searchFieldOnChange = (name, e) => {
        let searchparam = Object.assign({}, this.state.searchparam)
        searchparam[name] = e
        this.setState({ searchparam: searchparam })
    }

    onPageChange = (event) => {

        this.setState(
            {
                pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
                    loading: true,
                },
            },
            function () {
                this.getData();
            }
        );

    }


    onSelectionChange = (selectedRow) => {
        if (selectedRow.status !== "Submitted") {
            this.setState({
                selected: selectedRow,
                editable: true,
            });
        } else {
            this.setState({
                selected: {}
            })
        }
    }

    getCurrentDateTime = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })

            let url = `${API_URL}api/getcurrentdateandtime`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object
                        // console.log(dataObject);
                        // dataObject=dataObject.filter(function(element){
                        //     return element.id!==getUserId()
                        // })
                        this.setState({
                            currentDateTime: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            currentDateTime: "",
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        currentDateTime: "",
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getCurrentDateTime()
            }
        }
    }


    print = () => {
        if (this.state.data.length > 0) {
            window.print();
            window.location.reload();
        }

    }
    exportToExcel = () => {
        if (this.state.data.length > 0) {
            let data = this.state.data
            data = data.map(d => {
                d = {
                    Date: d.dateBs,
                    Project: d.projectId,
                    SubProject: d.subprojectId,
                    Description: d.description,
                    Timespent: d.timeSpent,
                    Comments: d.comments,
                    TimesheetOf: d.timesheetOf,
                    Status: d.status,
                    ApprovedBy: d.approvedBy
                }
                return d
            })
            data.push({
                Date: '',
                Project: '',
                SubProject: '',
                Description: 'Total',
                Timespent: this.state.totalTimeSpent,
                Comments: '',
                TimesheetOf: '',
                Status: '',
                ApprovedBy: ''
            })
            exportToCSV(data, "Timesheet Report" + Date());
        }

    }


    render() {
        const { total, pageNumber, pageSize } = this.state.pageOptions
        const { searchparam, isLoading, pageArray, permissions } = this.state
        const styles = { width: 110, height: 30 };
        return <div>

            {this.state.viewPermission === true ? (
                <div>

                    <Messager
                        ref={(ref) => (this.messager = ref)}
                    />
                    <div
                        className='loadingmodel'
                        style={{ display: isLoading ? "block" : "none" }}
                    ></div>
                    <div className='noprint'>
                        <DataGrid
                            data={pageArray}
                            clickToEdit
                            style={{ height: 132 }}
                            toolbar={({ editingItem }) => (
                                <div className='noprint' style={{ padding: 4 }}>
                                    <p className='text-danger'>Fields with * are mandatory</p>
                                    <b>User&nbsp;<span className='text-danger'>*</span>&nbsp;:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "130px", marginRight: "10px" }}
                                        data={this.state.user}
                                        valueField='id'
                                        textField='username'
                                        value={searchparam.userId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("userId", e)}
                                    ></ComboBox>
                                    &nbsp;

                                    <b>From date&nbsp;<span className='text-danger'>*</span>&nbsp;:</b>
                                    <DateBox
                                        format="yyyy-MM-dd"
                                        style={{ width: "150px", marginRight: "5px" }}
                                        value={searchparam.fromdate}
                                        onChange={(e) => this.searchFieldOnChange("fromdate", e)}
                                    >
                                    </DateBox>
                                    <b>To date&nbsp;<span className='text-danger'>*</span>&nbsp;:</b>&nbsp;
                                    <DateBox
                                        format="yyyy-MM-dd"
                                        style={{ width: "150px", marginRight: "5px" }}
                                        value={searchparam.todate}
                                        onChange={(e) => this.searchFieldOnChange("todate", e)}
                                    >
                                    </DateBox>

                                    <b>Project:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "130px", marginRight: "10px" }}
                                        data={this.state.projectList}
                                        valueField='id'
                                        textField='name'
                                        value={searchparam.projectId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("projectId", e)}
                                    ></ComboBox>


                                    <b>Sub-Project:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "130px", marginRight: "10px" }}
                                        data={this.state.subprojectList}
                                        valueField='id'
                                        textField='name'
                                        value={searchparam.subprojectId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("subprojectId", e)}
                                    ></ComboBox>


                                    <b>Status:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "100px", marginRight: "10px" }}
                                        data={this.state.statusData}
                                        value={searchparam.status}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("status", e)}
                                    ></ComboBox>
                                    &nbsp;
                                    <br />

                                    <div style={{ textAlign: "center", marginTop: "5px", marginBottom: "5px" }}>
                                        <LinkButton className="btn btn-primary mr-2" onClick={this.getData}>Generate</LinkButton>
                                        <LinkButton className="btn btn-success mr-2" onClick={this.exportToExcel}>Export</LinkButton>
                                        <LinkButton className="btn btn-info" onClick={this.print}>Print</LinkButton>
                                    </div>
                                </div>
                            )}>
                        </DataGrid>
                    </div>

                    {this.state.showReport ? (

                        <div className='mr-5 ml-5 '>
                            <h2 style={{ textAlign: "center" }}><b>Infox IT Pvt. Ltd</b></h2>
                            <h3 style={{ textAlign: "center" }}><b>Butwal-8, Sukkhanagar,Rupandehi</b></h3>
                            <h3 style={{ textAlign: "center" }}><b>Timesheet Report</b></h3>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-column">
                                    <h6 style={{ textAlign: "left" }}><b>Timesheet of&nbsp;:&nbsp;{this.state.data[0].timesheetOf}</b></h6>
                                    <h6 style={{ textAlign: "left", marginBottom: '10px' }}><b>Report generated at&nbsp;:&nbsp;{this.state.currentDateTime}</b></h6>
                                </div>

                                <div className='d-flex flex-column'>
                                    <h6 style={{ textAlign: "left" }}><b>From&nbsp;:&nbsp;{getFormattedDate(this.state.searchparam.fromdate)}</b></h6>
                                    <h6 style={{ textAlign: "left" }}><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To&nbsp;:&nbsp;{getFormattedDate(this.state.searchparam.todate)}</b></h6>
                                </div>
                            </div>

                            <table className='table report-table'>
                                <tr>
                                    <th>SN</th>
                                    <th>Date</th>
                                    <th>Project</th>
                                    <th>Subproject</th>
                                    <th>Description</th>
                                    <th>Timespent</th>
                                    <th>Comments</th>
                                    <th>Status</th>
                                    <th>Approved By</th>
                                </tr>
                                {this.state.data.map((d, index) => {
                                    return (
                                        <tr>
                                            <td width={"3%"}>{index + 1}</td>
                                            <td width={"10%"}>{d.dateBs}</td>
                                            <td width={"12%"}>{d.projectId}</td>
                                            <td width={"12%"}>{d.subprojectId}</td>
                                            <td width={"20%"}>{d.description}</td>
                                            <td width={"5%"}>{d.timeSpent}</td>
                                            <td width={"18%"}>{d.comments}</td>
                                            <td width={"5%"}>{d.status}</td>
                                            <td width={"12%"}>{d.approvedBy}</td>
                                        </tr>
                                    )
                                })}
                                <tr style={{ color: 'black' }}>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{this.state.totalTimeSpent}</b></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            </table>
                        </div>

                    ) : ""}
                </div>
            ) : ""}
        </div>;
    }
}

export default TimesheetSystemReport;
